<template>
  <div class="Pla-EscalaModelo-Menu">
    <PageTitle
      icon="fa fa-map"
      main="Escala Modelo"
      sub="Inforções de escala modelo e quadro de partidas"
    />
    <div class="Pla-EscalaModelo-Menu">
      <b-card no-body>
        <b-tabs>
          <b-tab title="Escala modelo" active><EscalaModelo /></b-tab>
          <b-tab title="Calendário de folga"><EscalaFolga /></b-tab>
          <b-tab title="Geração de escala diária"><EscalaDiaria /></b-tab>
          <b-tab title="Gestão da operação"><GestaoOperacao /></b-tab>
          <!--                                                                                                           
                    <b-tab title="Registro ponto eltrônico"><PontoEletronico/></b-tab>                 
                    <b-tab title="Upload de foto"><UploadFoto/></b-tab>  
                    -->
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import EscalaFolga from "../pla_linha/EscalaFolgas";
import EscalaModelo from "../pla_linha/EscalaModeloPadrao";
import EscalaDiaria from "../pla_linha/EscalaDiaria";
import GestaoOperacao from "../pla_linha/GestaoOperacao";
import PontoEletronico from "../pla_linha/EscalaPontoEletronico";
import UploadFoto from "../pla_linha/UploadFoto";
export default {
  name: "EscalaModeloMenu",
  components: {
    PageTitle,
    EscalaModelo,
    EscalaFolga,
    EscalaDiaria,
    GestaoOperacao,
    PontoEletronico,
    UploadFoto,
  },
};
</script>

<style>
</style>






